/*
* This code was initially copied from cloudacy vue-markdown-render.
* Version: 2.0.0, License: MIT
* Homepage: https://github.com/cloudacy/vue-markdown-render
*/
import { h, defineComponent } from 'vue';
import MarkdownIt from 'markdown-it';
import { hasKey } from "@/utils";

const MarkdownBulma = defineComponent({
    name: 'MarkdownRenderer',
    props: {
        source: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            required: false,
            default() {
                return {
                    html: true,
                    //breaks:true,
                    linkify: true,
                }
            }
        },
    },
    data: function () {
        return {
            md: null,
        };
    },
    computed: {
        content: function () {
            let _a;
            const src = this.source;
            return (_a = this.md) === null || _a === void 0 ? void 0 : _a.render(src);
        },
    },
    created: function () {
        let _a;
        const md = new MarkdownIt((_a = this.options) !== null && _a !== void 0 ? _a : {});

        const proxy = (tokens, idx, options, env, self) => self.renderToken(tokens, idx, options);

        /*
        * link_open,heading_open,inline,text,code_block,hr,html_block,fence,table_open,html_inline,code_inline,image,paragraph_open,s_open,strong_open
        */

        const defaultHeadingOpenRenderer = md.renderer.rules.heading_open || proxy;
        md.renderer.rules.heading_open = function (tokens, idx, options, env, self) {
            tokens[idx].attrJoin("class", "title");

            const mapping = { 'h1': 'is-1', 'h2': 'is-2', 'h3': 'is-3', 'h4': 'is-4', 'h5': 'is-5', 'h6': 'is-6' };
            const tag = tokens[idx].tag;
            if (hasKey(mapping, tag))
                tokens[idx].attrJoin("class", mapping[tokens[idx]['tag']]);

            return defaultHeadingOpenRenderer(tokens, idx, options, env, self)
        };

        this.md = md;

    },
    render: function () {
        return h('div', { innerHTML: this.content });
    },
});
export default MarkdownBulma;